<!-- Contenedor principal con layout responsive -->
<div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
  <!-- Columna Izquierda: Título y Descripción -->
  <div class="space-y-6">
    <!-- Campo Título -->
    <div>
      <label for="titulo" class="block text-sm font-semibold text-gray-800 mb-2">
        Título
        <span class="text-red-500">*</span>
      </label>
      <input
        type="text"
        id="titulo"
        placeholder="Ej: Turno Matutino, Jornada Nocturna"
        [formField]="formulario.titulo"
        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
        [class.p-invalid]="formulario.titulo().invalid() && formulario.titulo().touched()"
      />
      @if (formulario.titulo().invalid() && formulario.titulo().touched()) {
        <small class="p-error">{{ formulario.titulo().errors() | formErrorMessage }}</small>
      }
    </div>

    <!-- Campo Descripción -->
    <div>
      <label for="descripcion" class="block text-sm font-semibold text-gray-800 mb-2">
        Descripción
        <span class="text-red-500">*</span>
      </label>
      <textarea
        id="descripcion"
        rows="6"
        placeholder="Ingresa los detalles o notas sobre este periodo de tiempo..."
        [formField]="formulario.descripcion"
        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition resize-none"
        [class.p-invalid]="formulario.descripcion().invalid() && formulario.descripcion().touched()"
      ></textarea>
      @if (formulario.descripcion().invalid() && formulario.descripcion().touched()) {
        <small class="p-error">{{ formulario.descripcion().errors() | formErrorMessage }}</small>
      }
    </div>
  </div>

  <!-- Columna Derecha: Sección de Productos -->
  <app-agregar-producto-2 [(productos_carrito)]="productos_carrito" />
</div>

<!-- Botones de acción -->
<div class="flex gap-4 pt-6 border-t border-gray-200">
  <button
    type="button"
    class="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-lg transition"
    (click)="cerrar.emit()"
  >
    Cancelar
  </button>
  <button
    type="submit"
    class="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition shadow-md"
    [disabled]="formulario().invalid()"
    (click)="crear()"
  >
    <i class="bi bi-check-circle mr-2"></i>
    Guardar
  </button>
</div>
